// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 20H21V10C21 4.39943 16.4712 1 12 1C7.52879 1 3 4.39943 3 10V20H2V22H10V20H9V11H15V20H14V22H22V20ZM17 11H19V20H17V11ZM5 11H7V20H5V11ZM14 7H10V5H14V7Z"}}]};

const Dam3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-3-filled',
    ref,
    icon: element,
  },
));

Dam3FilledIcon.displayName = 'Dam3FilledIcon';

export default Dam3FilledIcon;
